var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShow = function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.046c1.818 0 3.291 1.557 3.291 3.477S11.818 15 10.001 15c-1.818 0-3.291-1.557-3.291-3.477S8.183 8.046 10 8.046ZM10 5c3.796 0 7.072 2.738 7.981 6.575.083.35-.118.703-.448.79-.33.088-.666-.124-.749-.473-.772-3.26-3.557-5.588-6.783-5.588-3.228 0-6.014 2.33-6.785 5.592-.083.349-.418.561-.748.474-.331-.087-.532-.441-.45-.79C2.927 7.74 6.204 5 10.002 5Z",
    fill: "#666"
  })));
};
export default SvgShow;